import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FaIconLibrary, FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faUpload } from '@fortawesome/pro-light-svg-icons';
import { FileUploadDialogModule } from '@y42/core/dialog/file-upload-dialog';
import { IntercomModule } from '@y42/intercom';
import { ImportTemplateButtonComponent } from './import-template-button.component';
import { ImportTemplateToastMessageComponent } from './import-template-toast-message.component';

@NgModule({
  imports: [
    CommonModule,
    MatButtonModule,
    FontAwesomeModule,
    MatTooltipModule,
    MatMenuModule,
    FileUploadDialogModule,
    IntercomModule,
  ],
  declarations: [ImportTemplateButtonComponent, ImportTemplateToastMessageComponent],
  exports: [ImportTemplateButtonComponent],
})
export class ImportTemplateModule {
  constructor(library: FaIconLibrary) {
    library.addIcons(faUpload);
  }
}
